import { useCallback, useMemo, useState } from 'react';
import type { HelpViewEntry } from '../../types';

const HOME_ENTRY: HelpViewEntry = { view: 'home' };

export const useHelpNavigationStack = () => {
  const [stack, setStack] = useState<HelpViewEntry[]>([HOME_ENTRY]);

  const current = stack[stack.length - 1];

  const push = useCallback((entry: HelpViewEntry) => {
    setStack((prev) => [...prev, entry]);
  }, []);

  const back = useCallback(() => {
    setStack((prev) => (prev.length > 1 ? prev.slice(0, -1) : prev));
  }, []);

  const goHome = useCallback(() => {
    setStack([HOME_ENTRY]);
  }, []);

  return useMemo(
    () => ({
      current,
      canGoBack: stack.length > 1,
      push,
      back,
      goHome,
    }),
    [current, stack.length, push, back, goHome]
  );
};

export default useHelpNavigationStack;
